import {MutationTree} from 'vuex';
import {ChatPrompt, FriendState, Meetup, UserWithMessage, WebRTCRequest} from './types';
import {MAFUser, UserTransaction} from '@/store/User/types';
import * as _ from 'lodash';

export const mutations: MutationTree<FriendState> = {
  setChatPrompt(state, payload: ChatPrompt | undefined): void {
    if (state) {
      state.chatPrompts = payload;
    }
  },

  setFriends(state, payload: MAFUser[] | undefined): void {
    if (state) {
      state.friends = payload;
    }
  },

  setFriendTransactions(state, payload: UserTransaction[]) {
    if (state) {
        state.transactions = payload;
    }
  },

  setToWebRequest(state, payload: WebRTCRequest[] | undefined): void {
    if ( state ) {
      state.toConnections = payload;
      if ( state.senderConnections && state.toConnections ) {
        const concat = state.senderConnections.concat(state.toConnections);
        _.sortBy(concat, ['sent']);
        state.connections = concat;
      } else if ( state.toConnections ) {
        _.sortBy(payload, ['sent']);
        state.connections = payload;
      }
    }
  },

  setSenderWebRequest(state, payload: WebRTCRequest[] | undefined): void {
    if ( state ) {
      state.senderConnections = payload;
      if ( state.senderConnections && state.toConnections ) {
        const concat = state.senderConnections.concat(state.toConnections);
        _.sortBy(concat, ['sent']);
        state.connections = concat;
      } else if ( state.senderConnections ) {
        _.sortBy(payload, ['sent']);
        state.connections = payload;
      }
    }
  },

  setWebRequest(state, payload: WebRTCRequest[] | undefined): void {
    if ( state ) {
      state.connections = payload;
    }
  },

  setMessages(state, payload: UserWithMessage[] | undefined): void {
    if (state) {
      state.messages = payload;
    }
  },

  setCurrentlyChattingWith(state, payload: MAFUser | undefined): void {
    if (state) {
      state.currentlyChattingWith = payload;
    }
  },

  setMeetups(state, payload: Meetup[]) {
    if (state) {
      state.meetups = payload;
    }
  },
};
